<template>
  <p v-html="transform(this.str)" class="custom-p-label"></p>
</template>

<script>
// 占位替换
const tempReg = /\{n\d{1,}\}/g

// 图标替换
const beanImgReg = /\s*#bean#\s*/g
const coinImgReg = /\s*#coin#\s*/g
const coinsImgReg = /\s*#coins#\s*/g
const beerImgReg = /\s*#beer#\s*/g
const chatPassImgReg = /\s*#chatPass#\s*/g
const videoPassImgReg = /\s*#videoPass#\s*/g
const callPassImgReg = /\s*#callPass#\s*/g
const ticketImgReg = /\s*#ticket#\s*/g
const trophyImgReg = /\s*#trophy#\s*/g
const starImgReg = /\s*#star#\s*/g
const iconImgReg = /\s*#icon#\s*/g

export default {
  props: {
    str: {
      type: String,
      default: '',
    },
    numsOption: {
      type: Array,
      default: () => {
        return [
          // {
          //   value: '',
          //   style: 'color: red'
          // }
        ]
      },
    },
    customClass: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /** #icon# 对应的图片地址（完整 URL） */
    iconUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    transform(str) {
      const packageType = this.packageName

      const nums = str.match(tempReg)
      if (nums && nums.length) {
        nums.forEach((numStrItem) => {
          const index = numStrItem.match(/\d{1,}/)[0]
          const targetObj = this.numsOption[index]
          if (targetObj) {
            str = str.replace(
              new RegExp('\\s*\\{n' + index + '\\}\\s*', 'g'),
              `<i class="unique-nums ${targetObj.class || ''}"  style="${targetObj.style || ''}">${targetObj.value || ''}</i>`
            )
          }
        })
      }

      const beans = str.match(beanImgReg)
      if (beans && beans.length) {
        str = str.replace(beanImgReg, `<span class="unique-bean-icon ${packageType}-bean ${this.customClass.bean || ''}"></span>`)
      }

      const coins = str.match(coinImgReg)
      if (coins && coins.length) {
        str = str.replace(coinImgReg, `<span class="unique-coin-icon ${packageType}-coin ${this.customClass.coin || ''}"></span>`)
      }

      const coinsStack = str.match(coinsImgReg)
      if (coinsStack && coinsStack.length) {
        str = str.replace(coinsImgReg, `<span class="unique-coins-icon ${packageType}-coins ${this.customClass.coins || ''}"></span>`)
      }

      const beers = str.match(beerImgReg)
      if (beers && beers.length) {
        str = str.replace(beerImgReg, `<span class="unique-beer-icon ${packageType}-beer ${this.customClass.beer || ''}"></span>`)
      }

      const chatPass = str.match(chatPassImgReg)
      if (chatPass && chatPass.length) {
        str = str.replace(chatPassImgReg, `<span class="unique-chatpass-icon ${packageType}-chatpass ${this.customClass.chatPass || ''}"></span>`)
      }

      const videoPass = str.match(videoPassImgReg)
      if (videoPass && videoPass.length) {
        str = str.replace(videoPassImgReg, `<span class="unique-videopass-icon ${packageType}-videopass ${this.customClass.videoPass || ''}"></span>`)
      }

      const callPass = str.match(callPassImgReg)
      if (callPass && callPass.length) {
        str = str.replace(callPassImgReg, `<span class="unique-callpass-icon ${packageType}-callpass ${this.customClass.callPass || ''}"></span>`)
      }

      const tickets = str.match(ticketImgReg)
      if (tickets && tickets.length) {
        str = str.replace(ticketImgReg, `<span class="unique-ticket-icon ${this.customClass.ticket || ''}"></span>`)
      }

      const trophies = str.match(trophyImgReg)
      if (trophies && trophies.length) {
        str = str.replace(trophyImgReg, `<span class="unique-trophy-icon ${this.customClass.trophy || ''}"></span>`)
      }

      const stars = str.match(starImgReg)
      if (stars && stars.length) {
        str = str.replace(starImgReg, `<span class="unique-star-icon ${this.customClass.star || ''}"></span>`)
      }

      const icons = str.match(iconImgReg)
      if (icons && icons.length) {
        const src = this.iconUrl ? String(this.iconUrl).replace(/"/g, '&quot;') : ''
        str = str.replace(iconImgReg, src ? `<img class="unique-icon-img ${this.customClass.icon || ''}" src="${src}" alt="" />` : '')
      }

      return str
    },
  },
}
</script>
<style lang="scss">
// nums
.custom-p-label {
  font-family: var(--string-font);
}

.unique-nums {
  display: inline-block;
  margin: 0 3px;
  font-family: var(--number-font);
  font-style: normal;
  vertical-align: middle;
}

// 图标/数字与文字垂直居中微调：vertical-align: middle 对齐 x-height 中点，图标视觉偏下，上移 2px 修正
.custom-p-label [class*='unique-'] {
  position: relative;
  top: -1.5px;
}

// 相邻替换节点（数字 / 图标）只保留一侧间距，避免 2px+2px 叠加
.custom-p-label [class*='unique-'] + [class*='unique-'] {
  margin-left: 0;
}

// beer
.unique-beer-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 3px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/common/beer.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

// bean
.unique-bean-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 3px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/packages/vava/beans.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-bean {
  background-image: url('~@/assets/packageAssets/packages/echo/beans.webp');
}

.joychat-bean {
  background-image: url('~@/assets/packageAssets/packages/joychat/beans.webp');
}

.joyu-bean {
  background-image: url('~@/assets/packageAssets/packages/joyu/beans.webp');
}

.kiko-bean {
  background-image: url('~@/assets/packageAssets/packages/kiko/beans.webp');
}

.vava-bean {
  background-image: url('~@/assets/packageAssets/packages/vava/beans.webp');
}

.vibeo-bean {
  background-image: url('~@/assets/packageAssets/packages/vibeo/beans.webp');
}

.whonow-bean {
  background-image: url('~@/assets/packageAssets/packages/whonow/beans.webp');
}

// coin
.unique-coin-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 3px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/packages/vava/coin.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-coin {
  background-image: url('~@/assets/packageAssets/packages/echo/coin.webp');
}

.joychat-coin {
  background-image: url('~@/assets/packageAssets/packages/joychat/coin.webp');
}

.joyu-coin {
  background-image: url('~@/assets/packageAssets/packages/joyu/coin.webp');
}

.kiko-coin {
  background-image: url('~@/assets/packageAssets/packages/kiko/coin.webp');
}

.vava-coin {
  background-image: url('~@/assets/packageAssets/packages/vava/coin.webp');
}

.vibeo-coin {
  background-image: url('~@/assets/packageAssets/packages/vibeo/coin.webp');
}

.whonow-coin {
  background-image: url('~@/assets/packageAssets/packages/whonow/coin.webp');
}

// coins (multi-coin stack)
.unique-coins-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 3px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/packages/vava/coins.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-coins {
  background-image: url('~@/assets/packageAssets/packages/echo/coins.webp');
}

.joychat-coins {
  background-image: url('~@/assets/packageAssets/packages/joychat/coins.webp');
}

.joyu-coins {
  background-image: url('~@/assets/packageAssets/packages/joyu/coins.webp');
}

.kiko-coins {
  background-image: url('~@/assets/packageAssets/packages/kiko/coins.webp');
}

.vava-coins {
  background-image: url('~@/assets/packageAssets/packages/vava/coins.webp');
}

.vibeo-coins {
  background-image: url('~@/assets/packageAssets/packages/vibeo/coins.webp');
}

.whonow-coins {
  background-image: url('~@/assets/packageAssets/packages/whonow/coins.webp');
}

// chatPass
.unique-chatpass-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;

  background-image: url('~@/assets/packageAssets/packages/vava/chat-pass.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-chatpass {
  background-image: url('~@/assets/packageAssets/packages/echo/chat-pass.webp');
}

.joychat-chatpass {
  background-image: url('~@/assets/packageAssets/packages/joychat/chat-pass.webp');
}

.joyu-chatpass {
  background-image: url('~@/assets/packageAssets/packages/joyu/chat-pass.webp');
}

.kiko-chatpass {
  background-image: url('~@/assets/packageAssets/packages/kiko/chat-pass.webp');
}

.vava-chatpass {
  background-image: url('~@/assets/packageAssets/packages/vava/chat-pass.webp');
}

.vibeo-chatpass {
  background-image: url('~@/assets/packageAssets/packages/vibeo/chat-pass.webp');
}

.whonow-chatpass {
  background-image: url('~@/assets/packageAssets/packages/whonow/chat-pass.webp');
}

// videoPass
.unique-videopass-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;

  background-image: url('~@/assets/packageAssets/packages/vava/video-pass.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-videopass {
  background-image: url('~@/assets/packageAssets/packages/echo/video-pass.webp');
}

.joychat-videopass {
  background-image: url('~@/assets/packageAssets/packages/joychat/video-pass.webp');
}

.joyu-videopass {
  background-image: url('~@/assets/packageAssets/packages/joyu/video-pass.webp');
}

.kiko-videopass {
  background-image: url('~@/assets/packageAssets/packages/kiko/video-pass.webp');
}

.vava-videopass {
  background-image: url('~@/assets/packageAssets/packages/vava/video-pass.webp');
}

.vibeo-videopass {
  background-image: url('~@/assets/packageAssets/packages/vibeo/video-pass.webp');
}

.whonow-videopass {
  background-image: url('~@/assets/packageAssets/packages/whonow/video-pass.webp');
}

// callPass
.unique-callpass-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;

  background-image: url('~@/assets/packageAssets/packages/vava/call-pass.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-callpass {
  background-image: url('~@/assets/packageAssets/packages/echo/call-pass.webp');
}

.joychat-callpass {
  background-image: url('~@/assets/packageAssets/packages/joychat/call-pass.webp');
}

.joyu-callpass {
  background-image: url('~@/assets/packageAssets/packages/joyu/call-pass.webp');
}

.kiko-callpass {
  background-image: url('~@/assets/packageAssets/packages/kiko/call-pass.webp');
}

.vava-callpass {
  background-image: url('~@/assets/packageAssets/packages/vava/call-pass.webp');
}

.vibeo-callpass {
  background-image: url('~@/assets/packageAssets/packages/vibeo/call-pass.webp');
}

.whonow-callpass {
  background-image: url('~@/assets/packageAssets/packages/whonow/call-pass.webp');
}

// ticket
.unique-ticket-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 3px;
  vertical-align: middle;

  background-image: url('~@/views/P5_Activitys/ActMidEast/images/male/draw-ticket.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

// star（大奖钥匙 / 宝箱）
.unique-star-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 3px;
  vertical-align: middle;

  background-image: url('~@/views/P5_Activitys/ActMidEast/images/male/chest-icon.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

// trophy
.unique-trophy-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 3px;
  vertical-align: middle;

  background-image: url('~@/views/P5_Activitys/ActMidEast/images/male/trophy.webp');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

// #icon# 动态图
.unique-icon-img {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 3px;
  vertical-align: middle;
}
</style>
